import $http from '../../shared/http';

export default {
  namespaced: true,
  state: () => {
    return {
      currentFinancialRequest: null,
      financialRequestsForSelect: [],
    };
  },
  getters: {
    getCurrentFinancialRequest: (state) => state.currentFinancialRequest,
    getFinancialRequestsForSelect: (state) => state.financialRequestsForSelect,
  },
  mutations: {
    setCurrentFinancialRequest: (state, payload) => (state.currentFinancialRequest = payload),
    setFinancialRequestsForSelect: (state, payload) => (state.financialRequestsForSelect = payload),
  },
  actions: {
    async CREATE_FINANCIAL_REQUEST(ctx, form) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post('financial-requests', form, { headers: { 'X-Is-Notifiable': 'On' } })
          .then((response) => {
            return resolve(response.data.data);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },
    async EDIT_FINANCIAL_REQUEST(ctx, { form, id }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .put(`financial-requests/${id}`, form, { headers: { 'X-Is-Notifiable': 'On' } })
          .then((response) => {
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },
    async DELETE_FINANCIAL_REQUEST(ctx, { id }) {
      return $http()
        .delete(`financial-requests/${id}`, { notifiable: true })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    async LOAD_FINANCIAL_REQUEST({ commit }, id) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`financial-requests/${id}`)
          .then((response) => {
            commit('setCurrentFinancialRequest', response.data.data);
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },
  },
};
